import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { subscribeEmail, resetSubscribe } from '../lib/actions/subscribeActions';

// isPro + savableCount fournis par le Verdict.
function EmailCapture({ isPro, savableCount = 0 }) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const steamId = useSelector((s) => s.scan.steamId);
  const { loading, success, error, message } = useSelector((s) => s.subscribe);
  const [email, setEmail] = useState('');

  useEffect(() => () => dispatch(resetSubscribe()), [dispatch]);

  const submit = (e) => {
    e.preventDefault();
    dispatch(subscribeEmail({ steamId, email, locale: i18n.resolvedLanguage }));
  };

  // Non-Pro : upsell vers l'offre payante, avec les 2 alertes mises en avant.
  if (isPro === false) {
    return (
      <section className="email email--locked">
        <span className="email__lock" aria-hidden="true">🔒</span>
        <h2 className="email__title">{t('email.locked_title')}</h2>
        <ul className="email__benefits">
          <li>
            <span className="email__benefit-ico" aria-hidden="true">🔔</span>
            <span>{t('email.benefit_danger')}</span>
          </li>
          <li>
            <span className="email__benefit-ico" aria-hidden="true">💶</span>
            <span>
              {savableCount > 0 ? (
                <>
                  <strong className="email__benefit-hl">
                    {t('email.benefit_price_head', { count: savableCount })}
                  </strong>{' '}
                  {t('email.benefit_price_tail')}
                </>
              ) : (
                t('email.benefit_price')
              )}
            </span>
          </li>
        </ul>
        <a className="btn btn--amber" href="/tarifs">{t('email.go_pro')}</a>
        <p className="email__pro-note">{t('email.pro_required')}</p>
      </section>
    );
  }

  if (success) {
    return (
      <section className="email email--done">
        <p className="email__done">✓ {message || t('email.success_fallback')}</p>
      </section>
    );
  }

  // Chargement du statut : placeholder discret.
  if (isPro === null) {
    return (
      <section className="email">
        <h2 className="email__title">{t('email.title')}</h2>
        <p className="email__subtitle">…</p>
      </section>
    );
  }

  // Pro : formulaire d'alerte actif.
  return (
    <section className="email">
      <span className="email__pro-badge">PRO ✓</span>
      <h2 className="email__title">{t('email.title')}</h2>
      <p className="email__subtitle">{t('email.subtitle')}</p>
      <form className="email__form" onSubmit={submit}>
        <input
          type="email"
          required
          placeholder={t('email.placeholder')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit" className="btn btn--mint" disabled={loading}>
          {loading ? t('email.sending') : t('email.button')}
        </button>
      </form>
      {error && <p className="email__error">{t('email.error')}</p>}
    </section>
  );
}

export default EmailCapture;
